import { styled, Avatar } from '@mui/material';

export const InitialSetupWizardWelcomeAvatar = styled(Avatar)(({ theme }) => ({
  width: 80,
  height: 80,
  boxShadow: theme.shadows[3],
}));
